import { glideConfig } from "../gallery/_glide-slider";

function initializeHomepageNewsStack() {
    const glideRoot = document.querySelector("[data-headline-stack] .glide");
    if (!glideRoot) return;

    const slidesUl = glideRoot.querySelector(".glide__slides");
    if (!slidesUl) return;

    const bulletsContainer = glideRoot.querySelector(".glide__bullets");

    // Count existing slides as defined in the template
    const slides = slidesUl.querySelectorAll(":scope > li.glide__slide");

    // Ensure bullets match the number of slides
    if (bulletsContainer) {
        const bulletNodes = Array.from(
            { length: Math.max(slides.length, 1) },
            (_, i) => {
                const btn = document.createElement("button");
                btn.className = "w-2 h-2 rounded-full glide__bullet bg-l1";
                btn.setAttribute("data-glide-dir", `=${i}`);
                btn.setAttribute("aria-label", "pagination");
                return btn;
            },
        );
        bulletsContainer.replaceChildren(...bulletNodes);
    }

    // Initialize glide without rebuilding slides
    glideConfig(glideRoot, {
        type: "slider",
        touchAngle: 45,
        focusAt: 0,
        startAt: 0,
        keyboard: true,
        gap: 10,
        rewind: false,
    });
}

function initializeHomepageNewsStackV2() {
    const glideRoot = document.querySelector("[data-headline-stack] .glide");
    if (!glideRoot) return;

    const slidesUl = glideRoot.querySelector(".glide__slides");
    if (!slidesUl) return;

    const bulletsContainer = glideRoot.querySelector(".glide__bullets");

    // Count existing slides as defined in the template
    const slides = slidesUl.querySelectorAll(":scope > li.glide__slide");

    // Ensure bullets match the number of slides
    if (bulletsContainer) {
        const bulletNodes = Array.from(
            { length: Math.max(slides.length, 1) },
            (_, i) => {
                const btn = document.createElement("button");
                btn.className = "w-2 h-2 rounded-full glide__bullet bg-l1";
                btn.setAttribute("data-glide-dir", `=${i}`);
                btn.setAttribute("aria-label", "pagination");
                return btn;
            },
        );
        bulletsContainer.replaceChildren(...bulletNodes);
    }

    // Initialize glide without rebuilding slides
    glideConfig(glideRoot, {
        type: "slider",
        touchAngle: 45,
        focusAt: 0,
        startAt: 0,
        keyboard: true,
        gap: 10,
        rewind: false,
    });
}

function init() {
    const nesn = document.querySelector('[data-skin="skin-nesn.css"]');
    if (nesn) {
        initializeHomepageNewsStackV2();
    } else {
        initializeHomepageNewsStack();
    }
}

if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
} else {
    init();
}

export { initializeHomepageNewsStack };
